import { useRulesContext } from "../../../../hook/useRulesContext";
import ResultsInfo from "./tableElements/ResultsInfo";
import TableHeader from "./tableElements/TableHeader";
import TableBody from "./tableElements/TableBody";
import EmptyState from "./tableElements/EmptyState";
import TableFooter from "./tableElements/TableFooter";

export default function RulesTable() {
    const { filteredShortcodes, loading } = useRulesContext();

    return (
        <>
            {loading.shortcodes ? (
                <div className="min-h-[200px] flex items-center justify-center">
                    <div className="animate-pulse space-y-4 w-full p-6">
                        <div className="h-6 bg-gray-200 rounded w-full mb-4"></div>
                        <div className="h-6 bg-gray-200 rounded w-full mb-4"></div>
                        <div className="h-6 bg-gray-200 rounded w-full mb-4"></div>
                        <div className="h-6 bg-gray-200 rounded w-full mb-4"></div>
                        <div className="h-6 bg-gray-200 rounded w-full"></div>
                    </div>
                </div>
            ) : (
                <>
                    {filteredShortcodes.length > 0 ? (
                        <>
                            <ResultsInfo />
                            <div className="overflow-x-auto">
                                <table className="w-full">
                                    {/* Table Header */}
                                    <TableHeader />

                                    {/* Main content */}
                                    <TableBody />
                                </table>
                            </div>
                            <TableFooter />
                        </>
                    ) : (
                        <EmptyState />
                    )}
                </>
            )}
        </>
    );
}
